const json = `
{
  "label": "Select an exchange",
  "searchPlaceholder": "Search in list",
  "searchNoResult": "No result",
  "searchMatched": "Matched",

  "tree": [
    {
      "title": "All regions",
      "children": [
        {
          "title": "Africa",
          "children": [
            {
              "title": "Botswana",
              "children": [
                {
                  "title": "Botswana National Stock Exchange Market"
                }
              ]
            },
            {
              "title": "Egypt",
              "children": [
                {
                  "title": "The Egyptian Exchange"
                }
              ]
            },
            {
              "title": "Ghana",
              "children": [
                {
                  "title": "Ghana Stock Exchange"
                }
              ]
            },
            {
              "title": "Ivory Coast",
              "children": [
                {
                  "title": "Bourse des Valeurs d'Abidjan"
                }
              ]
            },
            {
              "title": "Kenya",
              "children": [
                {
                  "title": "Nairobi Stock Exchange"
                }
              ]
            },
            {
              "title": "Malawi",
              "children": [
                {
                  "title": "Malawi Stock Exchange"
                }
              ]
            },
            {
              "title": "Mauritius",
              "children": [
                {
                  "title": "Stock Exchange of Mauritius"
                }
              ]
            },
            {
              "title": "Morocco",
              "children": [
                {
                  "title": "Casablanca Stock Exchange"
                }
              ]
            },
            {
              "title": "Namibia",
              "children": [
                {
                  "title": "Namibian Stock Exchange"
                }
              ]
            },
            {
              "title": "Nigeria",
              "children": [
                {
                  "title": "Nigerian Stock Exchange"
                }
              ]
            },
            {
              "title": "Rwanda",
              "children": [
                {
                  "title": "Rwanda Stock Exchange"
                }
              ]
            },
            {
              "title": "South Africa",
              "children": [
                {
                  "title": "4 Africa Exchange"
                },
                {
                  "title": "A2X Markets"
                },
                {
                  "title": "Johannesburg Stock Exchange"
                },
                {
                  "title": "JSE Yield X Exchange"
                },
                {
                  "title": "ZAR X (Pty) Ltd"
                }
              ]
            },
            {
              "title": "Swaziland",
              "children": [
                {
                  "title": "Swaziland Stock Exchange"
                }
              ]
            },
            {
              "title": "Tanzania",
              "children": [
                {
                  "title": "Dar es Salaam Stock Exchange"
                }
              ]
            },
            {
              "title": "Tunisia",
              "children": [
                {
                  "title": "Tunis Stock Exchange"
                }
              ]
            },
            {
              "title": "Uganda",
              "children": [
                {
                  "title": "Uganda Securities Exchange"
                }
              ]
            },
            {
              "title": "Zambia",
              "children": [
                {
                  "title": "Lusaka Stock Exchange"
                }
              ]
            },
            {
              "title": "Zimbabwe",
              "children": [
                {
                  "title": "Zimbabwe Stock Exchange"
                }
              ]
            }
          ]
        },
        {
          "title": "Asia Pacific",
          "children": [
            {
              "title": "Australia",
              "children": [
                {
                  "title": "Australian Securities Exchange"
                },
                {
                  "title": "Australian Securities Exchange 24"
                },
                {
                  "title": "Chi-X Australia"
                },
                {
                  "title": "National Stock Exchange of Australia"
                }
              ]
            },
            {
              "title": "Bangladesh",
              "children": [
                {
                  "title": "Dhaka Stock Exchange"
                }
              ]
            },
            {
              "title": "China",
              "children": [
                {
                  "title": "Shanghai International Energy Exchange"
                },
                {
                  "title": "Shanghai Stock Exchange"
                },
                {
                  "title": "Shenzhen Stock Exchange"
                }
              ]
            },
            {
              "title": "Hong Kong",
              "children": [
                {
                  "title": "Instinet Hong Kong"
                },
                {
                  "title": "Stock Exchange of Hong Kong Ltd"
                }
              ]
            },
            {
              "title": "India",
              "children": [
                {
                  "title": "BSE Ltd"
                },
                {
                  "title": "Calcutta Stock Exchange Association Ltd"
                },
                {
                  "title": "Metropolitan Stock Exchange"
                },
                {
                  "title": "National Stock Exchange of India"
                }
              ]
            },
            {
              "title": "Indonesia",
              "children": [
                {
                  "title": "Indonesia Stock Exchange (formerly Jakarta SE)"
                },
                {
                  "title": "Indonesia Stock Exchange (formerly Surabaya SE)"
                }
              ]
            },
            {
              "title": "Japan",
              "children": [
                {
                  "title": "Fukuoka Stock Exchange"
                },
                {
                  "title": "Nagoya Stock Exchange"
                },
                {
                  "title": "Osaka Securities Exchange"
                },
                {
                  "title": "Sapporo Securities Exchange"
                },
                {
                  "title": "Tokyo AIM"
                },
                {
                  "title": "Tokyo Stock Exchange Group"
                }
              ]
            },
            {
              "title": "Kazakhstan",
              "children": [
                {
                  "title": "Kazakstan Stock Exchange"
                }
              ]
            },
            {
              "title": "Laos",
              "children": [
                {
                  "title": "Lao Securities Exchange"
                }
              ]
            },
            {
              "title": "Malaysia",
              "children": [
                {
                  "title": "Bursa Malaysia Securities Bhd"
                }
              ]
            },
            {
              "title": "Mongolia",
              "children": [
                {
                  "title": "Mongolia Stock Exchange"
                }
              ]
            },
            {
              "title": "Myanmar",
              "children": [
                {
                  "title": "Yangon Stock Exchange"
                }
              ]
            },
            {
              "title": "New Zealand",
              "children": [
                {
                  "title": "New Zealand Exchange"
                }
              ]
            },
            {
              "title": "Pakistan",
              "children": [
                {
                  "title": "Pakistan Stock Exchange Ltd"
                }
              ]
            },
            {
              "title": "Philippines",
              "children": [
                {
                  "title": "Philippine Stock Exchange"
                }
              ]
            },
            {
              "title": "Singapore",
              "children": [
                {
                  "title": "Asia Pacific Exchange (APEX)"
                },
                {
                  "title": "Singapore Exchange Securities Trading Ltd"
                }
              ]
            },
            {
              "title": "South Korea",
              "children": [
                {
                  "title": "Korea Exchange - KOSDAQ"
                },
                {
                  "title": "Korea Exchange - KSE"
                },
                {
                  "title": "Korea New Exchange – KONEX"
                }
              ]
            },
            {
              "title": "Sri Lanka",
              "children": [
                {
                  "title": "Colombo Stock Exchange"
                }
              ]
            },
            {
              "title": "Taiwan",
              "children": [
                {
                  "title": "Taipei Exchange"
                },
                {
                  "title": "Taiwan Stock Exchange Corp"
                }
              ]
            },
            {
              "title": "Thailand",
              "children": [
                {
                  "title": "Stock Exchange of Thailand"
                }
              ]
            },
            {
              "title": "Vietnam",
              "children": [
                {
                  "title": "Hanoi Stock Exchange"
                },
                {
                  "title": "Hochiminh Stock Exchange"
                },
                {
                  "title": "Unlisted Public Company Market (UPCOM)"
                }
              ]
            }
          ]
        },
        {
          "title": "Europe",
          "children": [
            {
              "title": "Armenia",
              "children": [
                {
                  "title": "Nasdaq OMX Armenia open joint stock company (ARMEX)"
                }
              ]
            },
            {
              "title": "Austria",
              "children": [
                {
                  "title": "Derivatives Markets of Wiener Boerse"
                },
                {
                  "title": "EXAA Energy Exchange Austria"
                },
                {
                  "title": "NEWEX EDV Betriebssystem AG"
                },
                {
                  "title": "Vienna Stock Exchange"
                }
              ]
            },
            {
              "title": "Belgium",
              "children": [
                {
                  "title": "Belgian Futures And Options Exchange"
                },
                {
                  "title": "Euronext Brussels"
                }
              ]
            },
            {
              "title": "Bosnia and Herzegovina",
              "children": [
                {
                  "title": "Banja Luka Exchange"
                },
                {
                  "title": "Sarajevo Stock Exchange"
                }
              ]
            },
            {
              "title": "Bulgaria",
              "children": [
                {
                  "title": "Bulgarian Stock Exchange - Sofia"
                }
              ]
            },
            {
              "title": "Croatia",
              "children": [
                {
                  "title": "Zagreb Stock Exchange"
                }
              ]
            },
            {
              "title": "Cyprus",
              "children": [
                {
                  "title": "Cyprus Stock Exchange"
                }
              ]
            },
            {
              "title": "Czech Republic",
              "children": [
                {
                  "title": "Power Exchange Central Europe"
                },
                {
                  "title": "Prague Stock Exchange"
                }
              ]
            },
            {
              "title": "Denmark",
              "children": [
                {
                  "title": "Nasdaq Copenhagen"
                }
              ]
            },
            {
              "title": "Estonia",
              "children": [
                {
                  "title": "Nasdaq Tallin"
                }
              ]
            },
            {
              "title": "Finland",
              "children": [
                {
                  "title": "Investment Research Finland"
                },
                {
                  "title": "Nasdaq Helsinki"
                }
              ]
            },
            {
              "title": "France",
              "children": [
                {
                  "title": "Euronext Paris"
                },
                {
                  "title": "Morgan Stanley MTF"
                },
                {
                  "title": "NYSE Arca Europe"
                },
                {
                  "title": "NYSE BondMatch"
                },
                {
                  "title": "Sigma X"
                }
              ]
            },
            {
              "title": "Germany",
              "children": [
                {
                  "title": "Berlin Stock Exchange"
                },
                {
                  "title": "BOERSE DUESSELDORF–QUOTRIX"
                },
                {
                  "title": "Commodity Exchange Hannover"
                },
                {
                  "title": "Dusseldorf Stock Exchange"
                },
                {
                  "title": "EEX - European Energy Exchange"
                },
                {
                  "title": "Eurex Germany"
                },
                {
                  "title": "EUWAX - European Warrant Exchange"
                },
                {
                  "title": "Frankfurt Stock Exchange"
                },
                {
                  "title": "Hamburg Stock Exchange"
                },
                {
                  "title": "Hannover Stock Exchange"
                },
                {
                  "title": "iBOXX"
                },
                {
                  "title": "MTS Germany"
                },
                {
                  "title": "Munich Stock Exchange"
                },
                {
                  "title": "NASDAQ Germany"
                },
                {
                  "title": "Stuttgart Stock Exchange"
                },
                {
                  "title": "Tradegate"
                },
                {
                  "title": "Xetra"
                },
                {
                  "title": "Xetra International Market (XIM)"
                }
              ]
            },
            {
              "title": "Greece",
              "children": [
                {
                  "title": "Athens Stock Exchange"
                },
                {
                  "title": "Bank Of Greece"
                }
              ]
            },
            {
              "title": "Hungary",
              "children": [
                {
                  "title": "Budapest Stock Exchange"
                }
              ]
            },
            {
              "title": "Iceland",
              "children": [
                {
                  "title": "Nasdaq Iceland"
                }
              ]
            },
            {
              "title": "Ireland",
              "children": [
                {
                  "title": "Irish Futures and Options Market"
                },
                {
                  "title": "Irish Stock Exchange"
                }
              ]
            },
            {
              "title": "Italy",
              "children": [
                {
                  "title": "Milan Stock Exchange"
                }
              ]
            },
            {
              "title": "Latvia",
              "children": [
                {
                  "title": "Nasdaq Riga"
                }
              ]
            },
            {
              "title": "Lithuania",
              "children": [
                {
                  "title": "Nasdaq Vilnius"
                }
              ]
            },
            {
              "title": "Luxembourg",
              "children": [
                {
                  "title": "Luxembourg Stock Exchange"
                }
              ]
            },
            {
              "title": "Macedonia",
              "children": [
                {
                  "title": "Macedonia Stock Exchange"
                }
              ]
            },
            {
              "title": "Malta",
              "children": [
                {
                  "title": "Malta Stock Exchange"
                }
              ]
            },
            {
              "title": "Montenegro",
              "children": [
                {
                  "title": "Montenegro Stock Exchange"
                }
              ]
            },
            {
              "title": "Netherlands",
              "children": [
                {
                  "title": "Euronext Amsterdam"
                },
                {
                  "title": "European Options Exchange"
                }
              ]
            },
            {
              "title": "Norway",
              "children": [
                {
                  "title": "Norwegian Securities Dealers Association"
                },
                {
                  "title": "Oslo Børs"
                }
              ]
            },
            {
              "title": "Poland",
              "children": [
                {
                  "title": "PolPX Polish Power Exchange"
                },
                {
                  "title": "Warsaw Stock Exchange"
                }
              ]
            },
            {
              "title": "Portugal",
              "children": [
                {
                  "title": "Euronext Lisbon"
                },
                {
                  "title": "Interbolsa Portugal"
                },
                {
                  "title": "Oporto Derivatives Exchange"
                }
              ]
            },
            {
              "title": "Romania",
              "children": [
                {
                  "title": "Bucharest Stock Exchange"
                }
              ]
            },
            {
              "title": "Russian Federation",
              "children": [
                {
                  "title": "Moscow Interbank Currency Exchange (MICEX)"
                },
                {
                  "title": "Moscow Stock Exchange (MOSTEX)"
                },
                {
                  "title": "Russian Trading System (RTS)"
                },
                {
                  "title": "St Petersburg Stock Exchange"
                }
              ]
            },
            {
              "title": "Serbia",
              "children": [
                {
                  "title": "Belgrade Stock Exchange"
                }
              ]
            },
            {
              "title": "Slovakia",
              "children": [
                {
                  "title": "Bratislava Stock Exchange"
                }
              ]
            },
            {
              "title": "Slovenia",
              "children": [
                {
                  "title": "Ljubljana Stock Exchange"
                }
              ]
            },
            {
              "title": "Spain",
              "children": [
                {
                  "title": "Barcelona Stock Exchange"
                },
                {
                  "title": "Bolsa y Mercados Espanoles"
                },
                {
                  "title": "LATIBEX"
                },
                {
                  "title": "Madrid Stock Exchange"
                },
                {
                  "title": "MEFF Renta Fija"
                },
                {
                  "title": "MEFF Renta Variable"
                },
                {
                  "title": "Valencia Stock Exchange"
                }
              ]
            },
            {
              "title": "Sweden",
              "children": [
                {
                  "title": "BeQuoted"
                },
                {
                  "title": "Burgundy MTF"
                },
                {
                  "title": "Nasdaq Stockholm"
                },
                {
                  "title": "Nordic Growth Market / NDX"
                },
                {
                  "title": "Spotlight Stock Market"
                },
                {
                  "title": "Swedish Security Dealers Association"
                }
              ]
            },
            {
              "title": "Switzerland",
              "children": [
                {
                  "title": "Berne Stock Exchange"
                },
                {
                  "title": "SIX Swiss Exchange"
                },
                {
                  "title": "SWX INDICES"
                },
                {
                  "title": "VIRT-X"
                }
              ]
            },
            {
              "title": "Turkey",
              "children": [
                {
                  "title": "Borsa Istanbul A.S"
                },
                {
                  "title": "Istanbul Stock Exchange (Mutual Funds)"
                },
                {
                  "title": "Turkish Derivatives Exchange"
                }
              ]
            },
            {
              "title": "Ukraine",
              "children": [
                {
                  "title": "Perspektiva Stock Exchange"
                },
                {
                  "title": "PFTS Securities Trading System (Ukraine)"
                },
                {
                  "title": "Ukrainian Exchange"
                }
              ]
            },
            {
              "title": "United Kingdom",
              "children": [
                {
                  "title": "Aquis Exchange"
                },
                {
                  "title": "BATS CHI-X OTC"
                },
                {
                  "title": "BATS Trading Europe"
                },
                {
                  "title": "Chi-X Europe"
                },
                {
                  "title": "Chi-X MIFID"
                },
                {
                  "title": "Equiduct"
                },
                {
                  "title": "Euronext London"
                },
                {
                  "title": "ICAP Securities & Derivatives Exchange"
                },
                {
                  "title": "London Multi Asset Exchange"
                },
                {
                  "title": "London Stock Exchange plc"
                },
                {
                  "title": "Markit BOAT"
                },
                {
                  "title": "MIFID"
                },
                {
                  "title": "NASDAQ OMX Europe"
                },
                {
                  "title": "Plus Markets Group PLC"
                },
                {
                  "title": "Quote MTF"
                },
                {
                  "title": "The Order Machine (TOM) MTF"
                },
                {
                  "title": "Turquoise"
                }
              ]
            }
          ]
        },
        {
          "title": "Latin America and the Caribbean",
          "children": [
            {
              "title": "Argentina",
              "children": [
                {
                  "title": "Bolsa de Comercio de Buenos Aires"
                },
                {
                  "title": "Cordoba Stock Exchange"
                },
                {
                  "title": "Mercado a Termino de Buenos Aires SA"
                },
                {
                  "title": "Mercado a Termino de Rosario SA"
                },
                {
                  "title": "Mercado Abierto SA"
                }
              ]
            },
            {
              "title": "Bolivia",
              "children": [
                {
                  "title": "Bolivian Stock Exchange"
                }
              ]
            },
            {
              "title": "Brazil",
              "children": [
                {
                  "title": "Bolsa de Mercadorias e Futuros BM&F SA"
                },
                {
                  "title": "Bolsa de Valores do Estado de Sao Paulo"
                },
                {
                  "title": "Sociedade Operadora do Mercado de Ativos"
                }
              ]
            },
            {
              "title": "Cayman Islands",
              "children": [
                {
                  "title": "Cayman Islands Stock Exchange"
                }
              ]
            },
            {
              "title": "Chile",
              "children": [
                {
                  "title": "Bolsa de Comercio de Santiago"
                },
                {
                  "title": "Bolsa Electronica de Chile"
                }
              ]
            },
            {
              "title": "Colombia",
              "children": [
                {
                  "title": "Bolsa de Valores de Colombia"
                }
              ]
            },
            {
              "title": "Jamaica",
              "children": [
                {
                  "title": "Jamica Stock Exchange"
                }
              ]
            },
            {
              "title": "Mexico",
              "children": [
                {
                  "title": "Bolsa Institucional de Valores"
                },
                {
                  "title": "Bolsa Mexicana de Valores SA de CV"
                },
                {
                  "title": "Mercado Mexicano de Derivados, S.A. de C.V."
                }
              ]
            },
            {
              "title": "Paraguay",
              "children": [
                {
                  "title": "Bolsa de valores de Paraguay"
                }
              ]
            },
            {
              "title": "Peru",
              "children": [
                {
                  "title": "Bolsa de Valores de Lima S.A."
                }
              ]
            },
            {
              "title": "Venezuela",
              "children": [
                {
                  "title": "Bolsa de Valores de Caracas"
                }
              ]
            }
          ]
        },
        {
          "title": "Middle East",
          "children": [
            {
              "title": "Bahrain",
              "children": [
                {
                  "title": "Bahrain Bourse"
                }
              ]
            },
            {
              "title": "Iraq",
              "children": [
                {
                  "title": "Iraq Stock Exchange"
                }
              ]
            },
            {
              "title": "Israel",
              "children": [
                {
                  "title": "Tel Aviv Stock Exchange"
                }
              ]
            },
            {
              "title": "Jordan",
              "children": [
                {
                  "title": "Amman Financial Market"
                }
              ]
            },
            {
              "title": "Kuwait",
              "children": [
                {
                  "title": "Kuwait Stock Exchange"
                }
              ]
            },
            {
              "title": "Lebanon",
              "children": [
                {
                  "title": "Beirut Stock Exchange"
                }
              ]
            },
            {
              "title": "Occupied Palestinian Territory",
              "children": [
                {
                  "title": "Palestine Securities Exchange"
                }
              ]
            },
            {
              "title": "Oman",
              "children": [
                {
                  "title": "MUSCAT Securities Market"
                }
              ]
            },
            {
              "title": "Qatar",
              "children": [
                {
                  "title": "Qatar Exchange"
                }
              ]
            },
            {
              "title": "Saudi Arabia",
              "children": [
                {
                  "title": "Saudi Arabian Stock Exchange"
                }
              ]
            },
            {
              "title": "SYRIA",
              "children": [
                {
                  "title": "Damascus Securities Exchange"
                }
              ]
            },
            {
              "title": "United Arab Emirates",
              "children": [
                {
                  "title": "Abu Dhabi Stock Exchange"
                },
                {
                  "title": "Dubai Financial Market PJSC"
                },
                {
                  "title": "NASDAQ Dubai"
                }
              ]
            }
          ]
        },
        {
          "title": "North America",
          "children": [
            {
              "title": "Canada",
              "children": [
                {
                  "title": "Aequitas NEO-L"
                },
                {
                  "title": "Aequitas NEO-N"
                },
                {
                  "title": "CSE"
                },
                {
                  "title": "Lynx ATS"
                },
                {
                  "title": "Montréal Exchange"
                },
                {
                  "title": "Toronto Stock Exchange"
                },
                {
                  "title": "TSX Venture Exchange"
                }
              ]
            },
            {
              "title": "United States",
              "children": [
                {
                  "title": "CBOE BZX Exchange"
                },
                {
                  "title": "IEX Investors Exchange"
                },
                {
                  "title": "NASDAQ OMX"
                },
                {
                  "title": "National Stock Exchange"
                },
                {
                  "title": "New York Stock Exchange LLC"
                },
                {
                  "title": "NYSE American"
                },
                {
                  "title": "NYSE Arca"
                },
                {
                  "title": "OTC Bulletin Board"
                },
                {
                  "title": "OTC Markets"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}`

const data = JSON.parse(json)

export { data }
